// plugins/socket.js
import { io } from "socket.io-client";

let socket;

export default {
    install(app) {
        if (app.$store?.getters["auth/isAuthenticated"] === false) {
            console.warn("Socket not initialized: user not authenticated");
            return;
        }

        if (!socket) {
            socket = io(process.env.VUE_APP_BASE_API_URL, { autoConnect: true });
            const profile = app?.$store?.getters["auth/profile"];

            if (profile?._id) {
                socket.emit("register", profile._id);
                // console.log("Socket registered for user:", profile._id);
                console.log("Socket registered for user:");
            } else {
                console.warn("Socket connected but no profile to register");
            }

            socket.on("disconnect", (reason) => {
                console.warn("Global disconnect:", reason);
            });

            socket.on("connect_error", (err) => {
                console.error("Global socket error:", err.message);
            });
        }

        /**
         * Registers an event listener that automatically cleans itself
         * up when the component is unmounted.
         */
        app.config.globalProperties.$socketOn = function(event, handler) {
            socket.on(event, handler);

            // Get Vue instance
            const vm = this;
            
            if (!vm.__socketCleanup) {
                vm.__socketCleanup = [];
            }
            vm.__socketCleanup.push(() => {
                socket.off(event, handler);
            });
        };

        /**
         * Emit event wrapper
         */
        app.config.globalProperties.$socketEmit = function(event, payload) {
            socket.emit(event, payload);
        };

        /**
         * Called in beforeUnmount automatically
         */
        app.mixin({
            beforeUnmount() {
                const vm = this;

                if (vm.__socketCleanup) {
                    vm.__socketCleanup.forEach((off) => off());
                    vm.__socketCleanup = [];
                }
            },
        });

        // Make raw socket available if needed
        app.config.globalProperties.$socket = socket;
    },
};